import { useEffect } from "react";

const BASE_TITLE = "Rotimi Jacobs & Co — Legal Practitioners";
const BASE_DESC =
    "Rotimi Jacobs & Co, Legal Practitioners — Nigeria's leading authority in criminal prosecution, asset tracing, commercial litigation and corporate advisory since 1997.";

function setMeta(name, content, attr = "name") {
    if (!content) return;
    let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
}

/**
 * Lightweight per-page SEO. Sets title + meta description + og:* tags.
 */
export default function useSEO({ title, description, path } = {}) {
    useEffect(() => {
        const fullTitle = title ? `${title} — Rotimi Jacobs & Co` : BASE_TITLE;
        const desc = description || BASE_DESC;
        document.title = fullTitle;
        setMeta("description", desc);
        setMeta("og:title", fullTitle, "property");
        setMeta("og:description", desc, "property");
        setMeta("og:type", "website", "property");
        setMeta("twitter:card", "summary_large_image");
        if (path) {
            const canonical = `${window.location.origin}${path}`;
            let link = document.head.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);
            setMeta("og:url", canonical, "property");
        }
    }, [title, description, path]);
}
